<template>
    <div class="page">
        <div class="top">
            <div style="position: relative">
                <img
                    src="@/assets/imgs/img1.png"
                    class="img1" />
                <div class="Monto">Monto del préstamo: de $200 a $20,000</div>
                <img
                    src="@/assets/imgs/img2.png"
                    class="img2" />
                <div
                    class="ahora"
                    @click="goGooglePlay">
                    Descargar ahora
                </div>
            </div>
            <img
                src="@/assets/imgs/img3.png"
                class="img3" />
        </div>
        <div class="page-title">
            <div>Proceso de solicitud de préstamo de</div>
            <img
                src="@/assets/imgs/img1.png"
                class="img4" />
        </div>
        <div class="Proceso">
            <div class="Proceso-item">
                <img
                    src="@/assets/imgs/img15.png"
                    class="img15" />
                <div class="Proceso-title">Paso 1</div>
                <div class="Proceso-subtitle">Descargar la aplicación</div>
                <div class="Proceso-desc">Busque "Paay Prima" en la App Store y descárguela.</div>
            </div>
            <div
                class="Proceso-item"
                style="left: 50%">
                <img
                    src="@/assets/imgs/img15.png"
                    class="img15" />
                <div class="Proceso-title">Paso 2</div>
                <div class="Proceso-subtitle">Registrarse</div>
                <div class="Proceso-desc">Abra la aplicación y regístrese con su número de teléfono.</div>
            </div>
            <div class="Proceso-item Proceso3">
                <img
                    src="@/assets/imgs/img16.png"
                    class="img15" />
                <div class="Proceso-title">Paso 3</div>
                <div class="Proceso-subtitle">Ingresar información</div>
                <div class="Proceso-desc">Ingrese sus datos personales.</div>
                <div class="Proceso-desc">Cargue sus documentos de identificación.</div>
                <div class="Proceso-desc">Proporcione información de su cuenta bancaria para recibir el préstamo.</div>
            </div>
            <div class="Proceso-item Proceso4">
                <img
                    src="@/assets/imgs/img15.png"
                    class="img15" />
                <div class="Proceso-title">Paso 4</div>
                <div class="Proceso-subtitle">Solicitar y recibir el préstamo</div>
                <div class="Proceso-desc">Elija la cantidad y el plazo del préstamo que necesite.</div>
                <div class="Proceso-desc">Espere a que se apruebe su solicitud, lo que generalmente tarda unos minutos.</div>
                <div class="Proceso-desc">Una vez aprobado, confirme los términos y el dinero será transferido a su cuenta bancaria.</div>
            </div>
            <div class="Proceso-item Proceso5">
                <img
                    src="@/assets/imgs/img15.png"
                    class="img15" />
                <div class="Proceso-title">Paso 5</div>
                <div class="Proceso-subtitle">Realizar el pago</div>
                <div class="Proceso-desc">Pague según la fecha acordada,</div>
                <div class="Proceso-desc">a través de la aplicación o mediante transferencia bancaria.</div>
            </div>
        </div>
        <div class="page-title">
            <div>Requisitos del préstamo</div>
        </div>
        <div class="del">
            <img
                src="@/assets/imgs/img13.png"
                class="img5" />
            <div class="del-item">
                <img
                    src="@/assets/imgs/img4.png"
                    class="icon" />
                <div class="del-title">Mayor de edad</div>
                <div class="del-desc">El solicitante debe tener al menos 18 años.</div>
            </div>
            <div
                class="del-item"
                style="background-color: #5346ff">
                <img
                    src="@/assets/imgs/img5.png"
                    class="icon" />
                <div class="del-title">Tarjeta de banco</div>
                <div class="del-desc">Una tarjeta de banco válida para recibir la concesión de préstamos.</div>
            </div>
            <div
                class="del-item"
                style="background-color: #ebebeb">
                <img
                    src="@/assets/imgs/img6.png"
                    class="icon" />
                <div
                    class="del-title"
                    style="color: #000">
                    Buena reputación crediticia
                </div>
                <div
                    class="del-desc"
                    style="color: #000">
                    Debe tener una buena historial crediticio.
                </div>
            </div>
        </div>
        <div class="page-title">
            <div>Descripción del producto</div>
        </div>
        <div class="producto">
            <div style="display: flex; justify-content: space-between; margin-bottom: 80px">
                <div class="producto-item">
                    <img
                        src="@/assets/imgs/img7.png"
                        class="icon2" />
                    <div class="producto-desc">Monto del préstamo</div>
                    <div class="producto-title">de $200 a $20,000</div>
                </div>
                <div class="producto-item">
                    <img
                        src="@/assets/imgs/img8.png"
                        class="icon2" />
                    <div class="producto-desc">Tasa de Interés del crédito</div>
                    <div class="producto-title">0.01% diario a 0.08%</div>
                    <div class="producto-sub">Tasa de interés anual de 3.6% a 29.2%Dependiendo de la puntuación crediticia del usuario, puede haber fluctuaciones según el mercado.</div>
                </div>
                <div class="producto-item">
                    <img
                        src="@/assets/imgs/img9.png"
                        class="icon2" />
                    <div class="producto-desc">IVA</div>
                    <div class="producto-title">16%</div>
                </div>
            </div>
            <div style="display: flex; justify-content: space-around">
                <div class="producto-item">
                    <img
                        src="@/assets/imgs/img10.png"
                        class="icon2" />
                    <div class="producto-desc">Plazo del préstamo</div>
                    <div class="producto-title">de 90 a 120 días</div>
                </div>
                <div class="producto-item">
                    <img
                        src="@/assets/imgs/img11.png"
                        class="icon2" />
                    <div class="producto-desc">Tarifa de gestión</div>
                    <div class="producto-title">$0</div>
                </div>
            </div>
        </div>
        <div class="Ejemplo">
            <div class="Ejemplo-title">Ejemplo de Cálculo de Préstamo</div>
            <div class="Ejemplo-top">
                <div
                    class="red-title"
                    style="color: #fe953a">
                    Parámetros del Préstamo
                </div>
                <div class="red-desc">
                    <span style="color: #000000">Monto del préstamo</span>
                    <span style="color: #fe953a">6,000 MXN</span>
                </div>
                <div class="red-desc">
                    <span style="color: #000000">Plazo del préstamo</span>
                    <span style="color: #fe953a">90 días</span>
                </div>
                <div class="red-desc">
                    <span style="color: #000000">Tasa de interés diario</span>
                    <span style="color: #fe953a">0.08%</span>
                </div>
                <div class="red-desc">
                    <span style="color: #000000">Tasa de interés anual</span>
                    <span style="color: #fe953a">0.08% x 365 = 29.2%</span>
                </div>
            </div>
            <div class="red-box">
                <div class="red-title">Resultados del Cálculo</div>
                <div class="red-desc">
                    <span>Monto del préstamo</span>
                    <span>6,000 MXN</span>
                </div>
                <div class="red-desc">
                    <span>Plazo del préstamo</span>
                    <span>90 días</span>
                </div>
                <div class="red-desc">
                    <span>Interés total</span>
                    <span>432 MXN</span>
                </div>
                <div class="red-desc">
                    <span>IVA</span>
                    <span>69 MXN</span>
                </div>
                <div class="red-desc">
                    <span>Costo total</span>
                    <span>501 MXN</span>
                </div>
                <div
                    class="red-desc"
                    style="margin-bottom: 0">
                    <span>Monto total a pagar</span>
                    <span>6501 MXN</span>
                </div>
            </div>
            <div class="right-box">
                <div class="right-title">Parámetros del Préstamo</div>
                <div class="total">Calcular el interés total</div>
                <div class="total-desc">Interés diario = Monto del préstamo × Tasa de interés diario</div>
                <div class="total-desc">Interés diario = 6,000 MXN × 0.08% = 6,000 × 0.0008 = 4.8 MXN</div>
                <div class="total-desc">Interés total = Interés diario × Plazo del préstamo</div>
                <div class="total-desc last-desc">Interés total = 4.8 MXN × 90 días = 432 MXN</div>
                <div class="total">Calcular el IVA</div>
                <div class="total-desc">IVA = Interés total × 16%</div>
                <div class="total-desc last-desc">IVA = 432 MXN × 0.16 = 69 MXN</div>
                <div class="total">Calcular el costo total</div>
                <div class="total-desc">Costo total = Interés total + IVA</div>
                <div class="total-desc last-desc">Costo total = 432 MXN + 69 MXN = 501 MXN</div>
                <div class="total">Calcular el monto total a pagar</div>
                <div class="total-desc">Monto total a pagar = Monto del préstamo + Costo total</div>
                <div class="total-desc">Monto total a pagar = 6,000 MXN + 501 MXN = 6501 MXN</div>
                <br>
                <div class="total-desc" style="color: #fe953a;text-align: center;">· Para facilitar tus pagos, los montos se redondean hacia abajo.</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'App',
    data () {
        return {};
    },
    methods: {
        goGooglePlay () {
            window.open('https://paay.onelink.me/cvaC/zx105z1s');
        }
    },

};


</script>

<style scoped>
.top {
    display: flex;
    justify-content: space-between;
    margin-bottom: 150px;
    padding: 100px 360px;
    padding-bottom: 0;
}
.img1 {
    width: 261px;
    height: 57px;
    margin-bottom: 30px;
}
.Monto {
    width: 564px;
    font-weight: bold;
    font-size: 50px;
    color: #000000;
    margin-bottom: 119px;
}
.img2 {
    width: 187.99px;
    height: 170.85px;
    position: absolute;
    bottom: 70px;
    right: -40px;
}
.ahora {
    width: 349px;
    height: 86px;
    line-height: 86px;
    text-align: center;
    background: linear-gradient(336deg, #ff8630 0%, #fca948 100%);
    box-shadow: 0px 2px 13px 0px rgba(255, 134, 48, 0.75);
    border-radius: 43px;
    font-weight: bold;
    font-size: 30px;
    color: #ffffff;
    cursor: pointer;
}
.img3 {
    width: 431px;
    height: 429px;
}
.page-title {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    font-weight: bold;
    font-size: 40px;
    margin-bottom: 54px;
}
.img4 {
    width: 183px;
    height: 40px;
    margin-left: 20px;
}
.img5 {
    width: 469px;
    height: 322px;
}
.del {
    display: flex;
    justify-content: space-between;
    margin-bottom: 100px;
    padding: 0 360px;
}
.del-item {
    width: 222px;
    height: 322px;
    background: #fe953a;
    border-radius: 20px;
    padding: 43px 17px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
}
.icon {
    width: 30px;
    height: 30px;
    margin-bottom: 10px;
}
.del-title {
    font-weight: bold;
    font-size: 16px;
    color: #ffffff;
    margin-bottom: 14px;
}
.del-desc {
    font-size: 14px;
    color: #ffffff;
    line-height: 18px;
}
.producto {
    padding: 0 360px;
    margin-bottom: 100px;
}
.producto-item {
    width: 33.33%;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.icon2 {
    width: 64px;
    height: 64px;
    margin-bottom: 32px;
}
.producto-title {
    font-weight: bold;
    font-size: 30px;
    color: #000000;
}

.producto-desc {
    font-size: 20px;
    color: #000000;
    line-height: 30px;
    margin-bottom: 15px;
}
.producto-sub {
    width: 331px;
    font-size: 12px;
    color: #000000;
    line-height: 18px;
    margin-top: 10px;
    text-align: center;
}
.Ejemplo {
    height: 1052px;
    background-image: url('@/assets/imgs/img12.png');
    background-size: 100% 100%;
    padding: 100px 360px;
    padding-bottom: 68px;
    box-sizing: border-box;
    position: relative;
}
.Ejemplo-title {
    font-weight: bold;
    font-size: 40px;
    color: #000000;
    text-align: center;
}
.Ejemplo-top {
    width: 550px;
    padding: 35px 33px;
    box-sizing: border-box;
    font-size: 20px;
    margin-top: 88px;
}
.red-box {
    width: 550px;
    height: 376px;
    background: #fe953a;
    border-radius: 20px;
    backdrop-filter: blur(8px);
    margin-top: 42px;
    padding: 25px 33px;
    box-sizing: border-box;
    font-size: 20px;
}
.red-title {
    font-size: 30px;
    font-weight: bold;
    color: #5346ff;
    margin-bottom: 25px;
}
.red-desc {
    display: flex;
    justify-content: space-between;
    color: white;
    margin-bottom: 15px;
}
.right-box {
    width: 600px;
    height: 736px;
    margin-top: 42px;
    padding: 35px 25px;
    box-sizing: border-box;
    font-size: 20px;
    position: absolute;
    right: 360px;
    top: 200px;
}
.right-title {
    font-size: 30px;
    color: #fe953a;
    margin-bottom: 36px;
}
.total {
    font-weight: 20px;
    font-weight: bold;
    margin-bottom: 16px;
}
.total-desc {
    font-size: 18px;
}
.last-desc {
    margin-bottom: 40px;
}

.Proceso {
    height: 552px;
    background-image: url('@/assets/imgs/img14.png');
    background-size: 100% 100%;
    margin-bottom: 295px;
    position: relative;
}
.img15 {
    width: 60px;
    height: 60px;
    margin-bottom: 24px;
}
.Proceso-item {
    width: 674px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: -30px;
    position: absolute;
    left: 15%;
}
.Proceso-title {
    font-weight: bold;
    font-size: 24px;
    color: #fe953a;
    margin-bottom: 13px;
}
.Proceso-subtitle {
    font-weight: bold;
    font-size: 20px;
    color: #000000;
    margin-bottom: 10px;
}
.Proceso-desc {
    font-size: 16px;
    color: #000000;
    line-height: 24px;
}
.Proceso3 {
    left: 35%;
    top: 270px;
}
.Proceso4 {
    left: 15%;
    top: 552px;
}
.Proceso5 {
    left: 55%;
    top: 552px;
}
</style>
